export default "__VITE_ASSET__BwzbZAov__"